import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../environments/environment";
import { GenericHttpService } from "../../../services/generic-http.service";
import { Observable } from "rxjs";
import { GenericUtils } from "../../../utilities/generic-utils";
import { MessageService } from "../../../services/message-service"

@Injectable()
export class DataService {

  baseUrl = environment.gateWayHost;
  editItem: any;

  constructor(
    public generic: GenericHttpService,
    private utils: GenericUtils,
    private messageService: MessageService
  ) { }

  getLineData(url): Observable<any> {
    const option = {
      method: "GET",
      url: `${this.baseUrl}${url}`
    };

    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError));
  }
  getData(url, config, params): Observable<any> {
    url.includes('json') ? this.baseUrl = environment.baseUrl : this.baseUrl = environment.gateWayHost;
    const option = {
      method: "GET",
      url: `${this.baseUrl}${url}`,
      query: params
    };


    const functionToExecute = this[config.functionToCall].bind(this);
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(functionToExecute)
    );
  }

  processInboundOverallSLA(data) {
    if (!data.data.length) return null;
    const originalData = data.data[0][Object.keys(data.data[0])[0]][0];

    if (!originalData['eligible_quantity'] && !originalData['stocked_quantity']) return null;
    const dataToReturn = [
      [Number(originalData['sla'].toFixed(2))],
      [Number(originalData['sla_breach_0_12_sla'].toFixed(2))],
      [Number(originalData['sla_breach_12_24_sla'].toFixed(2))],
      [Number(originalData['sla_breach_gt_24_sla'].toFixed(2))],
      //[Number(originalData['sla'].toFixed(2))],
      ["Quantity Level"]
    ];
    const seriesName = [
      `In SLA - ${dataToReturn[0]}%`,
      `Out SLA +12 Hrs - ${dataToReturn[1]}%`,
      `Out SLA + 24 Hrs - ${dataToReturn[2]}%`,
      `Out SLA > 24 Hrs - ${dataToReturn[3]}%`
    ]
    const unstockedQuantity = 100 - (originalData['sla'] + originalData['sla_breach_0_12_sla'] + originalData['sla_breach_12_24_sla'] + originalData['sla_breach_gt_24_sla']);
    return { data: dataToReturn, displayText: `Unstocked Quantity % : ${unstockedQuantity.toFixed(2)}%`, seriesName };
  }
  processOutboundOverallSLA(data) {
    if (!data.data.length) return null;
    const originalData = data.data[0][Object.keys(data.data[0])[0]][0];

    if (!originalData['eligible_quantity'] && !originalData['stocked_quantity']) return null;
    const dataToReturn = [
      [Number(originalData['sla'].toFixed(2))],
      [Number(originalData['sla_breach_0_12_sla'].toFixed(2))],
      [Number(originalData['sla_breach_12_24_sla'].toFixed(2))],
      [Number(originalData['sla_breach_gt_24_sla'].toFixed(2))],
      ["Quantity Level"]
    ];
    const seriesName = [
      `In SLA - ${dataToReturn[0]}%`,
      `Out SLA +12 Hrs - ${dataToReturn[1]}%`,
      `Out SLA + 24 Hrs - ${dataToReturn[2]}%`,
      `Out SLA > 24 Hrs - ${dataToReturn[3]}%`
    ]
    const unshippedQuantity = 100 - (originalData['sla'] + originalData['sla_breach_0_12_sla'] + originalData['sla_breach_12_24_sla'] + originalData['sla_breach_gt_24_sla']);
    return { data: dataToReturn, displayText: `Unshipped Quantity % : ${unshippedQuantity.toFixed(2)}%`, seriesName };
  }

  transportationSLATotalFirtsAttempt(data: any) {
    if (!data.data && !data.data.length && !Object.keys(data.data[0])) return null;
    const originalData = data.data[0][Object.keys(data.data[0])[0]];

    if (originalData && originalData.length) {
      const dataToReturn = [], titleName = ['Total First Attempt %'];
      let totaldelivery = 0, totalfirstAttempt = 0;

      originalData.forEach((ele, i) => {
        if (ele.region === 'Total') {
          dataToReturn.push([+ele.first_attempt_qty_out_tat_1_sla.toFixed(2) || 0],
            [+ele.first_attempt_qty_out_tat_2_sla.toFixed(2) || 0],
            [+ele.first_attempt_qty_out_tat_3_sla.toFixed(2) || 0],
            [+ele.first_attempt_qty_out_tat_gt_3_sla.toFixed(2) || 0],
            [+ele.first_attempt_qty_undelivered_sla.toFixed(2)], titleName);

          totaldelivery = ((+ele.sla.toFixed(2) || 0));

          totalfirstAttempt = ((+ele.first_attempt_sla.toFixed(2) || 0))
        }
      });
      this.messageService.sendApiData({ dlvTotal: totaldelivery, firstAttTotal: totalfirstAttempt });

      return totalfirstAttempt ? { data: dataToReturn } : null;
    } else {
      this.messageService.sendApiData({ dlvTotal: 0, firstAttTotal: 0 });
      return null;
    }

  }

  transportationSLAFirtsAttempt(data: any) {
    if (!data.data && !data.data.length && !Object.keys(data.data[0])) return null;
    const originalData = data.data[0][Object.keys(data.data[0])[0]];

    if (originalData && originalData.length) {
      const dataToReturn = [], titleName = [];
      const tat1 = [], tat2 = [], tat3 = [], tat4 = [], undelivered = [];
      let total = 0;

      originalData.forEach((ele, i) => {
        if (ele.region !== 'Total') {
          titleName.push(ele.region)
          tat1.push(+ele.first_attempt_qty_out_tat_1_sla.toFixed(2) || 0);
          tat2.push(+ele.first_attempt_qty_out_tat_2_sla.toFixed(2) || 0);
          tat3.push(+ele.first_attempt_qty_out_tat_3_sla.toFixed(2) || 0);
          tat4.push(+ele.first_attempt_qty_out_tat_gt_3_sla.toFixed(2) || 0);
          undelivered.push(+ele.first_attempt_qty_undelivered_sla.toFixed(2) || 0);

          total += ((+ele.first_attempt_qty_out_tat_1_sla.toFixed(2) || 0) +
            (+ele.first_attempt_qty_out_tat_2_sla.toFixed(2) || 0) +
            (+ele.first_attempt_qty_out_tat_3_sla.toFixed(2) || 0) +
            (+ele.first_attempt_qty_out_tat_gt_3_sla.toFixed(2) || 0) +
            (+ele.first_attempt_qty_undelivered_sla.toFixed(2) || 0));
        }
      });
      dataToReturn.push(tat1, tat2, tat3, tat4, undelivered, titleName);
      return total ? { data: dataToReturn } : null;
    } else {
      return null;
    }
  }

  processTransportationDLVTotal(data: any) {
    if (!data.data && !data.data.length && !Object.keys(data.data[0])) return null;
    const originalData = data.data[0][Object.keys(data.data[0])[0]];

    if (originalData && originalData.length) {
      const dataToReturn = [], titleName = ['Total Delivery Attempt %'];
      let total = 0;

      originalData.forEach((ele, i) => {
        if (ele.region === 'Total') {
          dataToReturn.push([+ele.dlv_qty_out_tat_1_day_sla.toFixed(2) || 0],
            [+ele.dlv_qty_out_tat_2_day_sla.toFixed(2) || 0],
            [+ele.dlv_qty_out_tat_3_day_sla.toFixed(2) || 0],
            [+ele.dlv_qty_out_tat_gt_3_day_sla.toFixed(2) || 0],
            [+ele.dlv_qty_undelivered_sla.toFixed(2) || 0], titleName);

          total = ((+ele.dlv_qty_out_tat_1_day_sla.toFixed(2) || 0) +
            (+ele.dlv_qty_out_tat_2_day_sla.toFixed(2) || 0) +
            (+ele.dlv_qty_out_tat_3_day_sla.toFixed(2) || 0) +
            (+ele.dlv_qty_out_tat_gt_3_day_sla.toFixed(2) || 0) +
            (+ele.dlv_qty_undelivered_sla.toFixed(2) || 0));
        }
      });
      return total ? { data: dataToReturn } : null;
    } else {
      return null;
    }
  }

  processTransportationDLV(data: any) {
    if (!data.data && !data.data.length && !Object.keys(data.data[0])) return null;
    const originalData = data.data[0][Object.keys(data.data[0])[0]];

    if (originalData && originalData.length) {
      const dataToReturn = [], titleName = [];
      const tat1 = [], tat2 = [], tat3 = [], tat4 = [], undelivered = [];
      let total = 0;

      originalData.forEach((ele, i) => {
        if (ele.region !== 'Total') {
          titleName.push(ele.region)
          tat1.push(+ele.dlv_qty_out_tat_1_day_sla.toFixed(2) || 0);
          tat2.push(+ele.dlv_qty_out_tat_2_day_sla.toFixed(2) || 0);
          tat3.push(+ele.dlv_qty_out_tat_3_day_sla.toFixed(2) || 0);
          tat4.push(+ele.dlv_qty_out_tat_gt_3_day_sla.toFixed(2) || 0);
          undelivered.push(+ele.dlv_qty_undelivered_sla.toFixed(2) || 0);

          total += ((+ele.dlv_qty_out_tat_1_day_sla.toFixed(2) || 0) +
            (+ele.dlv_qty_out_tat_2_day_sla.toFixed(2) || 0) +
            (+ele.dlv_qty_out_tat_3_day_sla.toFixed(2) || 0) +
            (+ele.dlv_qty_out_tat_gt_3_day_sla.toFixed(2) || 0) +
            (+ele.dlv_qty_undelivered_sla.toFixed(2) || 0));
        }
      });
      dataToReturn.push(tat1, tat2, tat3, tat4, undelivered, titleName);
      return total ? { data: dataToReturn } : null;
    } else {
      return null;
    }
  }

  processfirstAttemptOverView(data: any) {
    if (!data.data && !data.data.length && !Object.keys(data.data[0])) return null;
    const originalData = data.data[0][Object.keys(data.data[0])[0]];

    if (originalData && originalData.length) {
      const dataToReturn = [], titleName = ['Total Fisrt Attempt %'];
      let totalfirstAttempt = 0;
      originalData.forEach((ele, i) => {
        if (ele.region === 'Total') {
          dataToReturn.push([+ele.dlv_qty_attempt_1_sla.toFixed(2) || 0],
            [+ele.dlv_qty_attempt_2_sla.toFixed(2) || 0],
            [+ele.dlv_qty_attempt_3_sla.toFixed(2) || 0],
            [+ele.dlv_qty_attempt_gt_3_sla.toFixed(2) || 0],
            [+ele.dlv_qty_attempt_undelivered_sla.toFixed(2) || 0], titleName);

          totalfirstAttempt = ((+ele.dlv_qty_attempt_1_sla.toFixed(2) || 0) +
            (+ele.dlv_qty_attempt_2_sla.toFixed(2) || 0) +
            (+ele.dlv_qty_attempt_3_sla.toFixed(2) || 0) +
            (+ele.dlv_qty_attempt_gt_3_sla.toFixed(2) || 0) +
            (+ele.dlv_qty_attempt_undelivered_sla.toFixed(2) || 0));
        }
      });
      return totalfirstAttempt ? { data: dataToReturn } : null;
    } else {
      return null;
    }
  }

  processfirstAttemptAnalysis(data: any) {
    if (!data.data && !data.data.length && !Object.keys(data.data[0])) return null;
    const originalData = data.data[0][Object.keys(data.data[0])[0]];

    if (originalData && originalData.length) {
      const dataToReturn = [], titleName = [];
      const tat1 = [], tat2 = [], tat3 = [], tat4 = [], undelivered = [];
      let totalfirstAttempt = 0;
      originalData.forEach((ele, i) => {
        if (ele.region !== 'Total') {
          titleName.push(ele.region)
          tat1.push(+ele.dlv_qty_attempt_1_sla.toFixed(2) || 0);
          tat2.push(+ele.dlv_qty_attempt_2_sla.toFixed(2) || 0);
          tat3.push(+ele.dlv_qty_attempt_3_sla.toFixed(2) || 0);
          tat4.push(+ele.dlv_qty_attempt_gt_3_sla.toFixed(2) || 0);
          undelivered.push(+ele.dlv_qty_attempt_undelivered_sla.toFixed(2) || 0);

          totalfirstAttempt += ((+ele.dlv_qty_attempt_1_sla.toFixed(2) || 0) +
            (+ele.dlv_qty_attempt_2_sla.toFixed(2) || 0) +
            (+ele.dlv_qty_attempt_3_sla.toFixed(2) || 0) +
            (+ele.dlv_qty_attempt_gt_3_sla.toFixed(2) || 0) +
            (+ele.dlv_qty_attempt_undelivered_sla.toFixed(2) || 0));
        }
      });
      dataToReturn.push(tat1, tat2, tat3, tat4, undelivered, titleName);
      return totalfirstAttempt ? { data: dataToReturn } : null;
    } else {
      return null;
    }
  }

  createChart(chartData, options) {
    const chart = this.utils.deepCopyFunction(options[0]);
    chart.xAxis.categories = chartData.data[chartData.data.length - 1];

    for (let i = 0; i < chartData.data.length - 1; i++) {
      chart.series[i].data = chartData.data[i];
      if (chartData.seriesName) {
        chart.series[i].name = chartData.seriesName[i];

      }
      //chart.series[i].name += ` - ${chartData.data[i]}%`;
    }
    return chart;
  }

}
